import { MediaContentShowcaseItem } from "onnit-ui/lib/module/MediaContentShowcase";

const ingredientsFocusBend: MediaContentShowcaseItem[] = [
    {
        image: `2023-NM-Wpage-keyIngredients-chamomileflowe.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Chamomile Flower",
        summary:
            "A flower whose name translates from ancient Greek as Earth Apple, for the pleasant aroma of its flowers.",
        detail:
            'Widely used, the chamomile flower has long been sought for its calming properties. <span class="oui-sup">&dagger;</span>'
    },
    {
        image: `2023-NM-Wpage-keyIngredients-valerianroot.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Valerian Root",
        summary:
            "Used since ancient Greece, Valerian root is a perennial flowering plant native to Europe and parts of Asia.",
        detail:
            'Promotes tranquility and sleep.<span class="oui-sup">&dagger;</span>'
    },
    {
        image: `2023-NM-Wpage-keyIngredients-lemonbalm.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Lemon Balm",
        summary:
            "A perennial herb in the mint family, native to southern Europe and the Mediterranean regions.",
        detail:
            'Studies have shown lemon balm to be helpful for  maintaining a positive mood.<span class="oui-sup">&dagger;</span>'
    },
    {
        image: `2023-NM-Wpage-keyIngredients-5htp.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "5-HTP",
        summary:
            'The direct precursor and metabolic intermediate of the neurotransmitter serotonin.<span class="oui-sup">&dagger;</span>',
        detail: 'Supports the body’s natural supply of serotonin.<span class="oui-sup">&dagger;</span>'
    },
    {
        image: `2023-NM-Wpage-keyIngredients-Tryptophan.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Tryptophan",
        summary:
            "An essential amino acid.",
        detail: 'Helps support 5-HTP levels. Tryptophan can also convert to melatonin, which promotes sleep.<span class="oui-sup">&dagger;</span>'
    }
];

export default ingredientsFocusBend;
